import { t } from "i18next";
import * as z from "zod";

import { NOTIFICATION_CHANNELS } from "@/features/shared/api/enums";

/**
 * Schéma du formulaire création/édition d'un fournisseur de transport
 * (`POST /NotificationProviders/add`, guide v2.3 §6.7).
 *
 * - `code` : chaîne MAJUSCULES uniquement (SMSPRO, XTECHNOLOGY, SMTP, FCM…).
 * - `config` : JSON **sans secret** — le back refuse toute clé évoquant
 *   `token` / `password` / `key`. L'UI valide juste la syntaxe JSON ; le refus
 *   des clés sensibles reste côté serveur.
 */
export const createNotificationProviderSchema = () =>
  z.object({
    code: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .regex(/^[A-Z0-9_]+$/, { message: t("invalidFieldError") }),
    name: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    channel: z.enum(NOTIFICATION_CHANNELS, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    countryCode: z
      .string()
      .trim()
      .max(3)
      .or(z.literal("")),
    weight: z.coerce.number().int().min(0).max(100),
    priority: z.coerce.number().int().min(1),
    isActive: z.boolean(),
    /** JSON brut (string) — parsé au submit. */
    configJson: z.string().trim(),
  });

export type NotificationProviderFormValues = z.infer<
  ReturnType<typeof createNotificationProviderSchema>
>;
